module.exports = __webpack_public_path__ + "static/media/spinner-lightbg-m.809e9d6b.gif";